import { useLanguage } from "../context/LanguageContext.jsx";
// Reconstructed from production code; original paths and local names were not available.
import { AppLoading } from "../components/AppLoading.jsx";
import { Navigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import * as jsxRuntime from "react/jsx-runtime";
import { useAuth } from "../context/AuthContext.jsx";
function ProtectedRoute() {
  const { tText } = useLanguage();
  const { user: user, authReady: authReady } = useAuth();
  return authReady ? (
    !user || !["ADMIN", "CAISSE"].includes(user.role) ? (
      <Navigate to={"/admin/login"} replace={true} />
    ) : (
      <Outlet />
    )
  ) : (
    <AppLoading
      variant={"page"}
      layout={"dashboard"}
      label={tText("Loading administration securely…")}
      detail={tText("Preparing your workspace.")}
    />
  );
}
export { ProtectedRoute };
